import { render, staticRenderFns } from "./send-new-ux.vue?vue&type=template&id=2f08d555&"
import script from "./send-new-ux.vue?vue&type=script&lang=js&"
export * from "./send-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f08d555')) {
      api.createRecord('2f08d555', component.options)
    } else {
      api.reload('2f08d555', component.options)
    }
    module.hot.accept("./send-new-ux.vue?vue&type=template&id=2f08d555&", function () {
      api.rerender('2f08d555', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/send-new-ux.vue"
export default component.exports